<div class="dashboard-header-container" [ngClass]="rootClassName">
  <div class="content">
    @if (isNavigationVisible) {
      <pop-ui-navigationbar [rootClassName]="'navigationbar'" [(state)]="navigation"></pop-ui-navigationbar>
    }
    @if (isSearchVisible) {
      <nx-superprep-searchbar [(search)]="search"></nx-superprep-searchbar>
    }
  </div>
  @if (!isDark && isWeb) { <hr class="divider" /> }
</div>
